import { render } from "./TeamDetail.vue?vue&type=template&id=29a8a393&scoped=true"
import script from "./TeamDetail.vue?vue&type=script&lang=js"
export * from "./TeamDetail.vue?vue&type=script&lang=js"

import "./TeamDetail.vue?vue&type=style&index=0&id=29a8a393&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a8a393"]])

export default __exports__